/* eslint-disable */
export default {
    Search: {
        btns: {
            protein: 'Protein',
            nucleotide: 'Nucleotides',
            nucleotideDb: 'Nucleotides database',
            proteinDb: 'Protein database',
            upload: 'Upload Sequence',
            delete: 'Delete',
            clear: 'Clear',
            addFragment: 'Add Fragment',
        },
        propver: {
            reset: 'Restore your setting',
            applyToAll: 'Apply to all queries',
            Preferences: {
                qconv: {
                    1: 'The higher you push this coverage %, the more similar sequences you receive.',
                    2: 'Use query coverage to determine the minimum % of your sequence that must be aligned to a result sequence. If the entire sequence is important, consider using a high percentage.',
                },
                gaps: {
                    1: 'Gaps will not necessarily increase or decrease your results, they will simply change the BLAST score for sequence alignments. ',
                    2: 'Matching with or without gaps indicates whether or not you want your sequence alignment to include gaps. Using gaps is great if there are regions within the sequences that are very similar but are separate by dissimilar regions. E.g:',
                    3: 'Patents can protect sequences within a certain % Identity, either with Gaps or without, so it is worth trying both.',
                },
                evalue: {
                    1: 'The higher you set this e-value threshold, the more results you are likely to see.',
                    2: 'E-Value indicates how likely it is that a sequence is similar to yours simply by chance. For instance, if your sequence is very short, there is a higher likelihood that it appears in several locations simply by chance. The greater the e-value, the more likely it is that this is just down to luck. ',
                },
                algorithm: {
                    megaBlast: 'Great for comparing very similar sequences',
                    blastn: 'Standard nucleotide-nucleotide comparisons',
                    blastnShort: 'Optimized for sequences with fewer than 50 nucleotides',
                    blastxFast: 'Use to search translated nucleotide-protein comparisons',
                    blastpFast: 'Faster version of Blastp that uses a larger word-size',
                    blastp: 'Standard protein-protein comparisons',
                    blastpShort: 'Optimized for sequences with fewer than 30 amino acids',
                    tblastnFast: 'Use to search translated protein-nucleotide comparisons',
                },
                lowComplexRegion: 'Mask regions of low compositional complexity that may cause spurious or misleading results.',
                defaultAlgorithm: 'Algorithm would change to blast-short when inputting short sequences.',
                slowWarning: 'The search might be longer against nucleotides databases by protein sequence！',
                algorithmDescription: {
                    1:
                      '<b>Global alignment algorithm</b> (such as Needleman-Wunsch) aligns two '
                      + 'sequences from beginning to end, aligning each letter in each sequence only '
                      + 'once. An alignment is produced, regardless of whether or not there is similarity '
                      + 'between the sequences.',
                    2:
                      '<b>Local alignment algorithm</b> (such as BLAST) can also be used to align two '
                      + 'sequences, but will only align those portions of the sequences that share '
                      + 'similarity. If there is no similarity, no alignment will be returned.',
                    3:
                      'Global alignment algorithm should only be used on sequences '
                      + 'that share significant similarity over most of their extents,'
                      + 'and then it will sometimes return a better presentation, especially for short sequences.',
                },
            },
        },
        labels: {
            refinements: 'PREFERENCES',
            predicted: 'Your input sequence type:',
            database: 'Search within:',
            advance: 'Advanced Preferences >',
            sequenceLength: 'Sequence Length',
            preferences: 'Preferences',
            countries: 'Countries',
            countriesTitle: 'Choose Jurisdictions',

            similarity: 'Alignment Identity (%)',
            qconv: 'Query Coverage (%) ',
            gaps: 'Match with gaps',
            evalue: 'E-Value',
            algorithm: 'Algorithm',
            matrix: 'Scoring matrix',
            wordSize: 'Word size',
            wordSizeHold: 'Initial seed length',
            gapCosts: 'Gap costs',
            matchScores: 'Reward/penalty for match/mismatch',
            matchScoresNoWrap: 'Reward/penalty for match/mismatch',
            proAutoAdjust:
                'Automatically adjust parameters for short input sequences. If selected, blastp-short will be used for sequences with 30 or fewer amino acids.',
            nuAutoAdjust:
                'Automatically adjust parameters for short input sequences. If selected, blastn-short will be used for sequences with fewer than 50 nucleotides.',
            threshold: 'Expect Threshold',
            yes: 'Yes',
            no: 'No',
            queryIdentity: 'Query Identity (%)',
            subjectIdentity: 'Subject Identity (%)',
            subjectCoverage: 'Subject Coverage (%)',
            subjectLength: 'Subject Length',
            subjectProteinLength: 'Subject Length（aa）',
            subjectNucLength: 'Subject Length（nt）',
            targetSeqLimit: 'Max Target Sequence',
            targetSeqLimitTooltip: 'Please contact customer service to upgrade your permissions.',
            millionOptionTooltip: 'When max target sequence is set to 500,000 or 1,000,000, the search speed will be very slow. Unless specifically required, it can be changed to 50,000',
            length: 'Length',
            multi: 'Multi',
            lowComplexRegion: 'Ignore low complexity regions',
            defaultAlgorithm: 'Default algorithm settings',
            searchParameters: 'Search parameters',
            algorithmSettings: 'Algorithm settings',
            databaseTitle: 'Database',
            mismatch: 'Mismatch',
            algorithmType: 'Search Algorithm',
            alignmentIdentity: 'Alignment Identity (%)',
            gapOpen: 'Gap Open Penalty',
            gapExtend: 'Gap Extension Penalty',
            scoreMatrix: 'Scoring Matrix',
            algorithmTypes: {
                Blast: 'Blast Search',
                Nw: 'Global Alignment Search',
            },
            nonShortSequence: 'Non-Short Sequences',
            shortSequence: 'Short Sequences',
        },
        explanation: {
            example: 'Example',
            identityLength: 'Identity Length',
            alignLength: 'Align Length',
            queryLength: 'Query Length',
            subjectLength: 'Subject Length',
            scoreMatrixDefaultTip: 'Match score and mismatch penalty are only effective under the DEFAULT matrix',
        },
    },
};
